// ============================================================================
// CHA-283 — shared Carbon class shorthands (the CodeRabbit follow-up).
// ============================================================================
// ONE home for the table-grammar class strings that were copy-pasted per file
// (CpscTable.CPSC_TH_CLASS + the local TH/CHIP/INPUT/BTN consts in
// FinanceDashboard, Production2Dashboard, BIDataSettings, AdminLookupManager,
// InventoryDashboard, …). The WorklistTable primitive consumes these; the
// existing per-file copies stay until CHA-287 migrates their surfaces —
// do NOT sweep-edit them ahead of that ticket.
//
// Values are byte-identical to the dominant existing copies so adopting the
// shared const is a no-op restyle.

// Mono uppercase header-cell text (eyebrow grammar) — the text-only piece,
// for CSS-grid header cells that carry their own padding/borders.
export const CARBON_TH_TEXT =
  'font-plex-mono text-[10px] tracking-[0.12em] uppercase font-normal text-carbon-gray-50';

// Full <th> class for real <table> headers (the TH const family).
export const CARBON_TH = `px-3 py-2 ${CARBON_TH_TEXT} border-b border-carbon-border`;

// Bordered mono status chip (the CHIP const family).
export const CARBON_CHIP =
  'font-plex-mono text-[9.5px] tracking-[0.08em] uppercase font-medium border px-2 py-0.5';

// Standard Carbon input (the INPUT const family).
export const CARBON_INPUT =
  'w-full px-3 py-2 text-sm bg-carbon-white text-carbon-ink border focus:outline-none focus:ring-1 focus:ring-carbon-blue-60';

// Button pair (the BTN_PRIMARY / BTN_OUTLINE const family).
export const CARBON_BTN_PRIMARY =
  'px-4 py-2 text-xs font-medium bg-carbon-ink text-carbon-white hover:bg-carbon-gray-80 disabled:opacity-50';
export const CARBON_BTN_OUTLINE =
  'px-4 py-2 text-xs font-medium bg-carbon-white border border-carbon-gray-30 text-carbon-ink hover:bg-carbon-gray-10 disabled:opacity-50';

// Mono filter chip — active = ink bg, white text (Orders reference filter-bar
// anatomy; same shape as OrdersDashboard's local carbonChipCls).
export const carbonFilterChip = (active) =>
  `font-plex-mono text-[11px] px-[11px] py-[5px] border transition-colors ${
    active
      ? 'bg-carbon-ink text-carbon-white border-carbon-ink'
      : 'bg-carbon-white text-carbon-gray-70 border-carbon-border hover:border-carbon-gray-50'
  }`;
